import FlatPickr from 'vue-flatpickr-component'
import { createHOCc } from 'vue-hoc'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js'
import { Polish } from 'flatpickr/dist/l10n/pl.js'

const LOCALE_MAP = {
  ru: Russian,
  uk: Ukrainian,
  pl: Polish,
}
const DEFAULT_LANG = LOCALE_MAP[window.language]

export const datepickerDefaults = createHOCc(
  {
    props: {
      config: {
        default: () => {},
      },
    },
  }, {
    props: {
      config() {
        return Object.assign({}, this.config, {
          locale: {
            ...DEFAULT_LANG,
            ...(this.config?.locale || {}),
          },
        })
  }

    },
  }
)
export default datepickerDefaults(FlatPickr)
